export default __webpack_public_path__ + "static/media/fallback_musician_preview_cmprs.e874b52a.jpg";